module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    attrs: {
      "offset": 4,
      "span": 16
    }
  }, [_c('logo', {
    attrs: {
      "title": _vm.title,
      "primary-color": _vm.primaryColor
    }
  }), _vm._v("\n    " + _vm._s(_vm.welcomeBody) + "\n    "), _c('br'), _c('br'), _vm._v(" "), _c('table', {
    staticStyle: {
      "margin": "auto",
      "width": "90%"
    },
    attrs: {
      "role": "presentation",
      "aria-hidden": "true",
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0",
      "align": "center"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.appleStore
    }
  }, [_c('img', {
    staticStyle: {
      "width": "95%",
      "height": "auto",
      "font-family": "sans-serif"
    },
    attrs: {
      "src": "/src/assets/img/appStoreBadge@2x.png",
      "aria-hidden": "true",
      "alt": "alt_text",
      "border": "0"
    }
  })])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.googlePlay
    }
  }, [_c('img', {
    staticStyle: {
      "width": "95%",
      "height": "auto",
      "font-family": "sans-serif"
    },
    attrs: {
      "src": "/src/assets/img/googlePlayBadge@2x.png",
      "aria-hidden": "true",
      "alt": "alt_text",
      "border": "0"
    }
  })])])])]), _vm._v(" "), (_vm.isMobile) ? _c('table', {
    staticStyle: {
      "margin": "auto",
      "width": "90%"
    },
    attrs: {
      "role": "presentation",
      "aria-hidden": "true",
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0",
      "align": "center"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "button-td",
    staticStyle: {
      "border-radius": "30px",
      "text-align": "center"
    },
    style: ({
      background: _vm.primaryColor
    })
  }, [_c('a', {
    staticClass: "button-a",
    staticStyle: {
      "border": "15px solid",
      "font-family": "'Nunito Sans', sans-serif",
      "font-size": "17px",
      "font-weight": "700",
      "line-height": "1.1",
      "text-align": "center",
      "text-decoration": "none",
      "display": "block",
      "border-radius": "30px"
    },
    style: ({
      background: _vm.primaryColor,
      'border-color': _vm.primaryColor
    }),
    attrs: {
      "href": _vm.url
    }
  }, [_c('span', {
    staticClass: "button-link",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("    Open App    ")])])])])]) : _vm._e(), _vm._v(" "), _c('company', {
    attrs: {
      "name": _vm.footer.companyName,
      "url": _vm.footer.companyUrl,
      "address": _vm.footer.companyAddress,
      "contact": _vm.footer.companyContact,
      "primary-color": _vm.primaryColor
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9ce85e8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/assets/pages/Confirmation/Confirmation.vue
// module id = 981
// module chunks = 3